import axios from 'axios';
import { spotifyClientId, spotifyAuthEndpoint, spotifyResponseType, scope, spotifyTokenEndpoint } from './credentials';

export async function axiosWrapper(method, url, data, headers={}) {
  console.log(method, url, data, headers)
  const response = await axios({
    method,
    url,
    headers,
    data
  }).catch((error) => {
    if (error.response) return {error: error.response};
    if (error.request) return {error: error.request};
    else return {error};
  })
  console.log(response);
  return response;
}


// Generates a random string for PKCE
export function generateCodeVerifier() {
  const array = new Uint32Array(56);
  window.crypto.getRandomValues(array);
  return Array.from(array, dec => ('0' + dec.toString(16)).substr(-2)).join('');
}

export async function generateCodeChallenge(codeVerifier) {
  const data = new TextEncoder().encode(codeVerifier);
  const digest = await window.crypto.subtle.digest("SHA-256", data);
  return btoa(String.fromCharCode(...new Uint8Array(digest)))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}


export function generateSpotifyRedirectURL(redirectUri, localStorage) {

  const codeChallenge = localStorage.getItem("spotify_code_challenge");

  const url = `${spotifyAuthEndpoint}?client_id=${spotifyClientId}&response_type=${spotifyResponseType}&redirect_uri=${redirectUri}&code_challenge_method=S256&code_challenge=${codeChallenge}&scope=${scope}`;
  return url;
  
}


export async function GenerateSpotifyAccessToken(code, localStorage, redirectUri) {

  const codeVerifier = localStorage.getItem("spotify_code_verifier");

  const body = new URLSearchParams({
    client_id: spotifyClientId,
    grant_type: "authorization_code",
    code,
    redirect_uri: redirectUri,
    code_verifier: codeVerifier
  });

  const headers = { "Content-Type": "application/x-www-form-urlencoded" };

  const response = await axiosWrapper("POST", spotifyTokenEndpoint, body, headers)

  //Add timestamp from call so I know when it will expire
  response.data.generated_at = Date.now();

  console.log(response);

  return response.data;
}


export async function RefreshSpotifyAccessToken(token) {

  console.log("Generating new token from refresh token");

  const body = new URLSearchParams({
    client_id: spotifyClientId,                         // required for PKCE refresh
    grant_type: "refresh_token",                        // tells Spotify we are refreshing
    refresh_token: token.refresh_token                  // use the token param
  });


  const headers = { "Content-Type": "application/x-www-form-urlencoded" };

  const response = await axiosWrapper("POST", spotifyTokenEndpoint, body, headers);

  const data = response.data;

  // Spotify DOES NOT always return a new refresh_token
  // Docs: reuse existing refresh_token if omitted
  if (!data.refresh_token) {
    data.refresh_token = token.refresh_token;
  }

  // Time stamp for local expiry tracking — matching your pattern
  data.generated_at = Date.now() + 100000000000;

  return data;
}
